/**!
 * Created by Leonardo Cheslacki on 18/07/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import StageController from './StageController';

import {HelpersIcon} from './../helpers';

import pageConfig from './../../../../config/page.config';

import WithType from './../WithType';

class StageSlider extends StageController {
    /**
     *
     * @param props
     * @param main
     * @returns {StageSlider}
     */
    constructor(props, main = {}) {
        super(props);

        // if (StageSlider._this instanceof StageSlider) {
        //     return StageSlider._this;
        // }

        this.props = props;
        this.main = main;

        this.state = {
            temp_pageX: 0,
            temp_pageY: 0,
            direction_x: null,
            direction_y: null,
            disabled: false,
            enabled: false
        };

        const {current_name} = this.props;

        this.$big_current_x = null;

        this.$helpersIcon = HelpersIcon(this)({current_name: current_name});

        StageSlider._this = this;
    };

    $functions = {

        /**
         *
         * @param event
         * @param _this_frame
         */
        handleSliderMouseDown: function (event, {_this_frame}) {
            const _this = StageSlider._this;
            const {stage, occ_slider} = _this_frame;

            let
                big_mouseX = (new Big(stage.mouseX)),
                big_scaleX = (new Big(stage.scaleX)),
                big_slider_x = (new Big(occ_slider.x));

            _this.setStateOccurrence(occ_slider, {big_offsetX: big_mouseX.div(big_scaleX).minus(big_slider_x)});
        },

        /**
         *
         * @param event
         * @param _this_frame
         */
        handleSlidePressMove: function (event, {_this_frame}) {
            const _this = StageSlider._this;
            const
                {stage, occ_slider} = _this_frame,
                {big_offsetX} = occ_slider.state;

            let
                big_mouseX = (new Big(stage.mouseX)),
                big_scaleX = (new Big(stage.scaleX)),
                big_position = big_mouseX.div(big_scaleX).minus(big_offsetX);

            _this.setCoordinateTransform(occ_slider, _this.bigToNumber(big_position, false, 'int'));

            _this.setDirection(event);
        },

        /**
         *
         * @param event
         * @param _this_frame
         */
        handleSliderMouseUp: function (event, {_this_frame}) {
            const _this = StageSlider._this;
            const {disabled} = _this.state;

            if (!_this.isEmpty(event)) {
                if (disabled) {
                    return _this.stopPropagation(event);
                } else {
                    _this.stopPropagation(event);
                }
            }

            _this.tickerSlider();
        },

        /**
         *
         * @param event
         * @param _this_frame
         */
        handleButtonMouseDown: function (event, {direction_x}) {
            const _this = StageSlider._this;
            const {disabled} = _this.state;

            if (!_this.isEmpty(event)) {
                if (disabled) {
                    return _this.stopPropagation(event);
                } else {
                    _this.stopPropagation(event);
                }
            }

            _this.setState({..._this.state, direction_x: direction_x}, _this.tickerSlider);
        },

        /**
         *
         * @param event
         * @param _this_frame
         * @param width
         * @param big_slider_width
         * @param callback
         */
        handleSlideTicker: function (event, {
            _this_frame,
            originalWidth,
            big_slider_width,
            callback
        }) {
            const _this = StageSlider._this;
            const
                {direction_x} = _this.state,
                {speed} = _this.props,
                {occ_slider} = _this_frame;

            let
                big_width = (new Big(originalWidth)),
                big_slider_x = (new Big(occ_slider.x)),
                big_speed = (new Big(speed)),
                big_x = ((direction_x === 'right') ? (big_slider_x.plus(big_speed)) : (direction_x === 'left') ? (big_slider_x.minus(big_speed)) : big_slider_x);

            !_this.$big_current_x && (_this.$big_current_x = big_width.neg());

            _this.state.disabled = true;

            if (big_x.lte(_this.$big_current_x) && (direction_x === 'left')) {
                (typeof (callback) === 'function') && callback(true);

                big_x = _this.$big_current_x;

                _this.$big_current_x = _this.$big_current_x.minus(big_width);

                _this.setButton(true, true);

                _this.state.disabled = false;
            } else if (big_x.gte(_this.$big_current_x.plus(big_width.times(_this.$controller.big_2))) && (direction_x === 'right')) {
                (typeof (callback) === 'function') && callback(true);

                big_x = _this.$big_current_x.plus(big_width.times(_this.$controller.big_2));

                _this.$big_current_x = _this.$big_current_x.plus(big_width);

                _this.setButton(true, true);

                _this.state.disabled = false;
            }

            if (big_x.lte(big_slider_width.minus(big_width).neg()) && (direction_x === 'left')) {
                (typeof (callback) === 'function') && callback(true);

                big_x = _this.$big_current_x.plus(big_width);

                _this.setButton(true, false);

                _this.state.disabled = false;
            } else if (big_x.gte(_this.$controller.big_0) && (direction_x === 'right')) {
                (typeof (callback) === 'function') && callback(true);

                big_x = _this.$controller.big_0;

                _this.setButton(false, true);

                _this.state.disabled = false;
            }

            occ_slider.x = _this.bigToNumber(big_x, false, 'int');

            //occ_slider.stage.update();
        },

        /**
         *
         * @param event
         * @param _this_frame
         */
        handleSliderTouch: function (event, {_this_frame}) {
            const _this = StageSlider._this;

            if (event.type === 'touchmove') {
                _this.stopPropagation(event);
            }

            let touches = ((typeof (event.targetTouches) === 'object') && event.targetTouches);

            if (touches && touches.length > 1) {
                return false;
            }

            const {stage, occ_slider} = _this_frame;

            let
                target_touch = event.targetTouches.item(0),
                big_clientX = (new Big(target_touch.clientX)),
                big_clientY = (new Big(target_touch.clientY)),
                big_scaleX = (new Big(stage.scaleX)),
                big_scaleY = (new Big(stage.scaleY)),
                big_slider_x = (new Big(occ_slider.x)),
                big_slider_y = (new Big(occ_slider.y)),
                big_slider_height = (new Big(occ_slider.nominalBounds.height)),
                big_positionX = big_clientX.div(big_scaleX).minus(big_slider_x),
                big_topVertical = _this.calcSize(_this.$controller.big_1, big_scaleY, big_slider_y, true),
                big_bottomVertical = big_topVertical.plus(_this.calcSize(_this.$controller.big_1, big_scaleY, big_slider_height, true));

            _this.state.enabled = !!(big_clientY.gte(big_topVertical) && big_clientY.lte(big_bottomVertical));

            if ((event.type === 'touchstart')) {
                _this.setStateOccurrence(occ_slider, {big_offsetX: big_positionX});
            } else if ((event.type === 'touchmove') && _this.state.enabled) {
                const {big_offsetX} = occ_slider.state;

                let big_position = big_clientX.div(big_scaleX).minus(big_offsetX);

                _this.setCoordinateTransform(occ_slider, _this.bigToNumber(big_position, false, 'int'));

                _this.setDirection(target_touch);
            }
        },

        /**
         *
         * @param event
         * @param _this_frame
         */
        handleSliderTouchEnd: function (event, {_this_frame}) {
            const _this = StageSlider._this;

            let touches = ((typeof (event.targetTouches) === 'object') && event.targetTouches);

            if (touches && touches.length > 1) {
                return false;
            }

            const {disabled} = _this.state;

            if (disabled) {
                return false;
            } else {
                _this.state.enabled && _this.tickerSlider();
            }
        }
    };

    tickerSlider = () => {
        const
            _this_frame = this.getFrame(),
            {occ_slider} = _this_frame,
            big_slider_width = (new Big(occ_slider.nominalBounds.width));

        this.destroyTicker('_handleSlider');

        createjs.Ticker.timingMode = createjs.Ticker.RAF;

        let composition = this.getComposition(this.props.current_name);
        this.isEmpty(composition) && (composition = this.getComposition(this.props.current_page));

        const {properties} = composition.getLibrary();

        let ticker = createjs.Ticker.on('tick', this.$functions.handleSlideTicker, false, false, {
            _this_frame: _this_frame,
            originalWidth: properties.width,
            big_slider_width: big_slider_width,
            callback: () => this.destroyTicker('_handleSlider')
        });

        this.setReferenceTicker('_handleSlider', ticker);
    };

    /**
     *
     * @param prev
     * @param next
     */
    setButton = (prev = false, next = false) => {
        const
            _this_current = this.get(),
            {color_icon} = this.props,
            {btn_prev, btn_next, occ_pseudo_prev, occ_pseudo_next, occ_icon_prev, occ_icon_next} = _this_current;

        this.$helpersIcon.setIcon(_this_current, color_icon);

        btn_prev.visible = prev;

        btn_next.visible = next;

        occ_pseudo_prev.visible = !prev;

        occ_pseudo_next.visible = !next;

        occ_icon_prev.occ_effect.occ_animate.visible = prev;

        occ_icon_next.occ_effect.occ_animate.visible = next;
    };

    startSlider = () => {
        const _this = StageSlider._this;
        const
            {btn_prev, btn_next} = this.get(),
            _this_frame = _this.getFrame(),
            {
                stage: {canvas},
                occ_slider
            } = _this_frame;

        occ_slider.x = 0;
        occ_slider.cursor = 'pointer';
        this.destroyTicker('_handleSlider');

        this.setHandleMouseDown(btn_prev, this.$functions.handleButtonMouseDown, {direction_x: 'right'});

        this.setHandleMouseDown(btn_next, this.$functions.handleButtonMouseDown, {direction_x: 'left'});

        this.setHandleMouseDown(occ_slider, this.$functions.handleSliderMouseDown, {_this_frame: _this_frame});

        this.setHandleMouseDown(occ_slider, this.$functions.handleSliderMouseUp, {_this_frame: _this_frame}, null, 'mouseup');

        this.setHandleMouseDown(occ_slider, this.$functions.handleSlidePressMove, {_this_frame: _this_frame}, null, 'pressmove');

        this.removeListener('touchstart', 'handle-slider-touch-touchstart', () => {
            this.addListener(canvas, 'touchstart', 'handle-slider-touch-touchstart', this.$functions.handleSliderTouch, {passive: true}, {
                _this_frame: _this_frame
            });
        });

        this.removeListener('touchmove', 'handle-slider-touch-touchmove', () => {
            this.addListener(canvas, 'touchmove', 'handle-slider-touch-touchmove', this.$functions.handleSliderTouch, false, {
                _this_frame: _this_frame
            });
        });

        this.removeListener('touchend', 'handle-slider-touch-touchend', () => {
            this.addListener(canvas, 'touchend', 'handle-slider-touch-touchend', this.$functions.handleSliderTouchEnd, {passive: true}, {
                _this_frame: _this_frame
            });
        });
    };

    mainSlider = () => {
        this.setButton(false, true);
        this.startSlider();
    };
}

/**
 *
 * @type {{}}
 */
StageSlider.propTypes = {
    current_name: PropTypes.string,
    current_page: PropTypes.string,
    color_icon: PropTypes.string,
    speed: PropTypes.number
};

/**
 *
 * @type {{}}
 */
StageSlider.defaultProps = {
    current_name: null,
    current_page: null,
    color_icon: pageConfig.button.color_icon,
    speed: 64
};

/**
 *
 * @type {{}}
 * @private
 */
StageSlider._this = {};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(StageSlider, {className: 'StageSlider'});
